import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { cancelReasons } from '../../utils/utils.common';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { ParserService } from 'src/app/component/broker-parser/planner-service/parser-service';
import { BrokerService } from 'src/app/service/broker-service/broker.service';
@Component({
  selector: 'app-cancel-trip-modal',
  templateUrl: './cancel-trip-modal.component.html',
  styleUrls: ['./cancel-trip-modal.component.css']
})
export class CancelTripModalComponent implements OnInit, OnDestroy {
  cancelReasons = [];
  @Input() tripData;
  @Input() isNoShow;
  @Input() componentType;
  @Output() cancelTripData = new EventEmitter<any>();
  @Output() onCloseModal = new EventEmitter<string>();
  multipleCancel = {}
  user;
  cancelReason;
  componentLoad = false;
  selectedReason = null;
  isViewReady = false;
  preCooperates = {};
  brokersSettingList: any;
  tripFundingSource: any;

  constructor(
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private corporateService: CorporateService,
    private parserService: ParserService,
    private brokerService: BrokerService
  ) { }

  ngOnInit() {
      this.getCorporate();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (this.tripData && this.tripData.changeReason) {
            this.cancelReason = this.tripData.changeReason;
          }
          if (this.tripData && this.tripData.cooperate) {
            this.tripFundingSource = this.preCooperates[this.tripData.cooperate];
            if (this.tripFundingSource.applyBrokerReasons) {
              this.cancelReasons = [];
              this.getBrokerCancelReasons();
              return;
            }
          }

          this.cancelReasons = cancelReasons;
          if (this.isNoShow) {
            this.cancelReasons = this.cancelReasons.filter(reason => {
              const myReason = reason.value.split(' - ');
              if (myReason && myReason[0] && myReason[0].toLowerCase().includes('dry run')) {

                return reason;
              }
              return null;
            })
          };
          const mySelected = this.cancelReasons.find(reason=> this.tripData && reason.value == this.tripData.changeReason);
          if(mySelected){
            this.selectedReason = mySelected;
          }

          this.isViewReady = true;
        }
      });
  }

  async getBrokerCancelReasons() {
    if (this.tripFundingSource) {
      const allSettings = await this.parserService.getBrokerSettingList().toPromise();
      if (allSettings && allSettings.length) {
        const settings = allSettings.find(broker => broker.name === this.tripFundingSource.companyType);
        if (settings) {
          const { username, password } = settings;
          const payload = {
            email: username,
            password,
            role: "company"
          }
          const token = await this.getBrokerToken(payload);
          if (token) {
            const res = await this.brokerService.getCancelReasons(token).toPromise();
            const { results } = res;
            if (results && results.length) {
              this.cancelReasons = results.map((reason: any) => ({
                id: reason.id,
                value: reason.title,
                label: reason.title,
                isBillable: reason.isBillable,
                isNoShow: reason.isNoShow
              })
              );

              const mySelected = this.cancelReasons.find(reason => this.tripData && reason.value == this.tripData.changeReason);
              if (mySelected) {
                this.selectedReason = mySelected;
              }
            }
          }
        }
      }
    } else {
      console.log('funding source does not exist');
    }
    this.isViewReady = true;
  }

  async getBrokerToken(payload) {
    let accessToken = '';
    const response = await this.brokerService.getToken(payload).toPromise();
    const {tokens} = response;
    if (tokens && tokens.access && tokens.access.token) {
      accessToken = tokens.access.token;
    } else {
      console.log('broker communication error');
    }
    return accessToken;
  }


    getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.getUser();
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  setReason(reason) {
    this.selectedReason = reason;
    this.cancelReason = reason.value;

    // if (this.componentType === 'Multiple Assign') {
    //   this.multipleCancel['changeReason'] = reason;
    // } else {
    //   this.tripData['changeReason'] = reason;
    // }
  }

  cancelJob() {
    if (this.componentType === 'Multiple Assign') {
      this.multipleCancel = {
        selectedTrips: this.tripData,
        status: 'cancelled',
        changeReason: this.cancelReason
      }
      if (this.tripData.jobType === 'cooperate') {
        this.multipleCancel = { ...this.multipleCancel, viewStatus: 'returned' }
      }

      if (this.tripData.isFinishedCalled) {
        this.multipleCancel = { ...this.multipleCancel, isFinishedCancelled: true }
      }

      if (this.selectedReason) {
        this.multipleCancel = { ...this.multipleCancel, isBillable: this.selectedReason.isBillable, isNoShow: this.selectedReason.isNoShow }
      }

      this.componentLoad = true;
      this.assignTripService
        .assignMultipleTrip(this.multipleCancel)
        .pipe(takeUntil(takeUntilDestroyed(this)))
        .subscribe(data => {
          if (data) {
            // sweetAlert('Success', "Trip Cancelled Successfully", 'success', 'OK')
            this.cancelTripData.emit(this.tripData);
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
    } else {
      this.tripData['changeReason'] = this.cancelReason;
      this.tripData['status'] = "cancelled";
      this.tripData['jobStatus'] = "cancelled";
      if (this.tripData.jobType === 'cooperate') {
        this.tripData['viewStatus'] = "returned";
      }
      if (this.tripData.isFinishedCalled) {
        this.tripData['isFinishedCancelled'] = true
      }
      this.componentLoad = true;

      if (this.selectedReason) {
        this.tripData['isBillable'] = this.selectedReason.isBillable;
        this.tripData['isNoShow'] = this.selectedReason.isNoShow;
      }

      if (this.isNoShow) {
        this.noShowCancelRequest();
      } else {
        this.simpleCancelRequest();
      }

    }
  }

  simpleCancelRequest() {
    this.assignTripService
      .removeTrip(this.tripData, this.tripData._id)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // sweetAlert('Success', "Trip Cancelled Successfully", 'success', 'OK')
          this.cancelTripData.emit(this.tripData);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      })
  }


  noShowCancelRequest() {
    this.assignTripService
      .noShowCancelTrip(this.tripData)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.cancelTripData.emit(this.tripData);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      })
  }

  closeCancelModal() {
    this.cancelTripData.emit();
  }

  onChangeReason(value) {

    if (value.length === 0) {
      this.selectedReason = null;
    }
  }

  ngOnDestroy(): void {
  }
}
